module.exports = {
  // 正式环境
  // baseUrl: 'https://server.qingguangtech.com/',
  // imageBaseUrl: 'https://src.qingguangtech.com/application',

  baseUrl: '/api/',
  imageBaseUrl: '/application',
  replyBuddyBaseUrl: '/reply_buddy/',

  // 测试环境
  // baseUrl: 'http://58.220.10.222:8082/',
  // imageBaseUrl: 'http://58.220.10.222:19000/application',
  version: process.env.VUE_APP_REQUEST_VERSION || 'prod',
  projectName: '协同管理系统'
}
